import ReactHtmlParser from 'react-html-parser';

const normalizeSnippetText = (value) => {
  if (!value || typeof value !== 'string') return '';
  return value
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

const extractDescriptionParagraphs = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value
      .flat()
      .map((item) => (typeof item === 'string' ? item.trim() : String(item)))
      .filter(Boolean);
  }
  if (typeof value !== 'string') {
    return [String(value)];
  }

  const cleaned = value.replace(/\r/g, '');
  const paragraphMatches = cleaned.match(/(<p[^>]*?>[\s\S]*?<\/p>)/gi);
  if (paragraphMatches && paragraphMatches.length) {
    return paragraphMatches.map((fragment) => fragment.trim());
  }

  return cleaned
    .split(/\n+/)
    .map((part) => part.trim())
    .filter(Boolean);
};

const renderRichText = (content) => {
  if (content === null || content === undefined) return null;
  if (typeof content === 'string') {
    return ReactHtmlParser(content);
  }
  return content;
};

const parseFailureSummary = (summary) => {
  if (!summary || typeof summary !== 'string') {
    return { intro: null, details: [], raw: summary || '' };
  }

  const cleaned = summary.replace(/\r/g, '');

  const segments = cleaned.split(/\n+/).reduce((acc, fragment) => {
    fragment
      .split(' — ')
      .map((part) => part.trim())
      .filter(Boolean)
      .forEach((part) => acc.push(part));
    return acc;
  }, []);

  if (!segments.length) {
    return { intro: null, details: [], raw: cleaned };
  }

  const [intro, ...details] = segments;
  return { intro, details, raw: cleaned };
};

export {
  extractDescriptionParagraphs,
  normalizeSnippetText,
  parseFailureSummary,
  renderRichText,
};
